// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"fedbf8e2","879":"3cec0a9b"}[chunkId] + ".chunk.css";
};